import { Injectable } from '@angular/core';
import { UserNotificationsService, UserNotificationType } from '@dn/libs/ui/dn-common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { pipe } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApplicationState } from '../../../reducers';
import { LoadUserNotification, SaveUserNotification } from '../action/notification.action';

@Injectable()
export class NotificationEffects {
  constructor(
    private readonly action$: Actions,
    private readonly userNotificationService: UserNotificationsService,
    private readonly store: Store<ApplicationState>,
  ) {}

  loadUserNotification$ = createEffect(() =>
      this.action$.pipe(
        ofType(LoadUserNotification),
        tap(({ userNotificationAlert }) => {
            this.userNotificationService.updateUserNotification(userNotificationAlert);
        }),
      ),
      { dispatch: false },
  );
}
